import React, { Component } from "react";
import { WelcomeImg } from "./assets/aws/QuickScreenerImageMapping";
import {
  TopBar,
  TopBarContent,
  LandingBody,
  LandingBodyBox,
  LandingBodyBoxContent,
  WelcomeImage,
  Centralise,
  Button,
} from "./styles/Theme";
import { RouteComponentProps, withRouter } from "react-router-dom";
import "../QuickScreener/styles/style.css";
import { DateInput } from "semantic-ui-calendar-react";
import {
  Grid,
  Icon,
  Select,
  Dimmer,
  Header,
  Message,
  Sidebar,
  SidebarPusher,
  Menu,
  Input,
  Modal,
} from "semantic-ui-react";
import "moment/locale/zh-cn";
import moment from "moment";
import { isBrowser } from "react-device-detect";
import { DesktopOrLaptop, TabletOrMobile } from "../QuickScreener/MediaQuery";
import { withTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";
import i18n from "i18next";
import Footer from "./Footer";
import Cookies from "js-cookie";
import api_address from "constants/config";
import axios from "axios";
import { PRODUCTS } from "constants/common";

interface LandingProps extends RouteComponentProps {
  history: any; // Replace 'any' with a more specific type if possible
  t: (key: string) => string;
  i18n: {
    language: string;
  };
  // Add any other props used in this component
}

interface LandingState {
  dateSel: string;
  sexSel: string;
  active: boolean;
  message: string;
  visible: boolean;
  locked: boolean;
  agentID: string;
  activationCode: string;
  isModalOpen: boolean;
  isAccessGranted: boolean;
  // Add any other state fields used in this component
}

class Landing extends Component<LandingProps, LandingState> {
  constructor(props: LandingProps) {
    super(props);
    this.state = {
      dateSel: "",
      sexSel: "",
      active: false,
      message: "",
      visible: false,
      locked: true,
      agentID: "",
      activationCode: "",
      isModalOpen: true, // The modal will be open by default when the page loads
      isAccessGranted: true, // By default, access is not granted
    };
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleSexChange = this.handleSexChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleVisible = this.handleVisible.bind(this);
  }

  handleOpen = () => this.setState({ active: true });
  handleClose = () => this.setState({ active: false });

  componentDidMount() {
    try {
      const token = Cookies.get("token") as string;
      if (!token) {
        this.props.history.push("/login");
      }
      setTimeout(async () => {
        // getting all the purchases / transaction history that has been made
        const purchasesRes = await axios.get(
          api_address + "api/user/purchases",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const { status: purchaseStatus, message: purchaseMessage } =
          purchasesRes.data;
        if (!purchaseStatus) {
          throw new Error(purchaseMessage);
        }
        const orders = purchasesRes.data.orders;

        // filter the orders only for "QuickScreener" product
        const qsOrders = orders.filter(
          (order) => order.name === PRODUCTS.QuickScreener
        );

        // query for all the completed quick screener result for this user
        const res = await axios.get(
          api_address + "api/quickScreenerResult/getQSResultByUserId",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const { qsResult } = res.data;
        // QS result only generated after you finish quick screener
        // If total of QS Result < Total number Order for Quick Screener
        // Give access to do quick screener
        if (qsResult.length < qsOrders.length) {
          document.body.style.backgroundColor = "#f1f1f1";
          i18n.changeLanguage("zh-TW");
          const { transactionId } = this.props.location.state || {};
        } else {
          this.props.history.push("/evaluation-history");
          return;
        }
      });
    } catch (err) {}
  }
  componentWillUnmount() {
    // Reset the background color when the component unmounts
    document.body.style.backgroundColor = "initial";
  }

  codeToText(languageCode) {
    if (languageCode === "zh-CN") {
      return "简体中文 (Chinese - Simplified)";
    } else if (languageCode === "zh-TW") {
      return "繁體中文 (Chinese - Traditional)";
    }
    return;
  }

  handleActivationCodeChange = (event) => {
    this.setState({ activationCode: event.target.value });
  };

  handleModalClose = () => {
    const { t } = this.props;
    if (this.state.activationCode === "NS2023") {
      this.setState({ isModalOpen: false, isAccessGranted: true });
    } else {
      alert(t("quickScreener.index.incorrectActivationCode"));
    }
  };

  handleChange = (event) => {
    const lang = event.currentTarget.textContent;

    if (lang === "简体中文 (Chinese - Simplified)") {
      i18n.changeLanguage("zh-CN");
    } else if (lang === "繁體中文 (Chinese - Traditional)") {
      i18n.changeLanguage("zh-TW");
    }
  };

  handleAgentIDChange = (event) => {
    this.setState({ agentID: event.target.value });
  };

  navigateToQuestionnaire = (index) => {
    const { transactionId } = this.props.location.state;
    const agentId = this.state.agentID ? this.state.agentID : "";
    this.props.history.push(
      `/quick-screener/questionnaire/${index}/${this.state.sexSel}/${this.state.dateSel}/${transactionId}/${agentId}`
    );
  };

  getDaysApart() {
    // Assuming format is in "mm-dd-yyyy" format
    const dateArray = this.state.dateSel.split("-");

    var dob = new Date(
      parseInt(dateArray[2]), // Year
      parseInt(dateArray[0]) - 1, // Month, adjusted for 0-index
      parseInt(dateArray[1]) // Day
    );

    // Normalize dob to the start of the day
    dob.setHours(0, 0, 0, 0);

    var today = new Date();
    // Normalize today to the start of the day
    today.setHours(0, 0, 0, 0);

    // To calculate the time difference of two dates
    var Difference_In_Time = today.getTime() - dob.getTime();

    // To calculate the no. of days between two dates
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

    return Difference_In_Days;
  }

  handleMobileChange(lang) {
    if (lang === "简体中文 (Chinese - Simplified)") {
      i18n.changeLanguage("zh-CN");
      this.handleVisible(false);
    } else if (lang === "繁體中文 (Chinese - Traditional)") {
      i18n.changeLanguage("zh-TW");
      this.handleVisible(false);
    }
  }

  onSubmit(event) {
    const sexSel = this.state.sexSel;
    const dateSel = this.state.dateSel;
    const { t } = this.props;
    console.log("onsubmit", sexSel, dateSel);
    if (sexSel.length === 0) {
      this.setState({ message: t("quickScreener.index.genderMessage") });
      this.setState({ active: true });
    } else if (dateSel.length === 0) {
      this.setState({ message: t("quickScreener.index.birthdayMessage") });
      this.setState({ active: true });
    } else {
      const monthDay = 30.436875;
      const exactDay = this.getDaysApart();
      console.log("exacDay", exactDay);

      // 3M16D ~ 5M15D
      if (3 * monthDay + 16 <= exactDay && exactDay <= 5 * monthDay + 15) {
        this.navigateToQuestionnaire(1);
        // 5M16D ~ 8M15D
      } else if (
        5 * monthDay + 15 < exactDay &&
        exactDay <= 8 * monthDay + 15
      ) {
        this.navigateToQuestionnaire(2);
        // 8M16D ~ 11M15D
      } else if (
        8 * monthDay + 15 < exactDay &&
        exactDay <= 11 * monthDay + 15
      ) {
        this.navigateToQuestionnaire(3);
        // 11M16D ~ 1Y2M15D
      } else if (
        11 * monthDay + 15 < exactDay &&
        exactDay <= 365 + 2 * monthDay + 15
      ) {
        this.navigateToQuestionnaire(4);

        // 1Y2M16D ~ 1Y5M15D
      } else if (
        365 + 2 * monthDay + 15 < exactDay &&
        exactDay <= 365 + 5 * monthDay + 15
      ) {
        this.navigateToQuestionnaire(5);
        // 1Y5M16D ~ 1Y11M15D
      } else if (
        365 + 5 * monthDay + 15 < exactDay &&
        exactDay <= 365 + 11 * monthDay + 15
      ) {
        this.navigateToQuestionnaire(6);
        // 1Y11M16D ~ 2Y5M15D
      } else if (
        365 + 11 * monthDay + 15 < exactDay &&
        exactDay <= 2 * 365 + 5 * monthDay + 15
      ) {
        this.navigateToQuestionnaire(7);
        // 2Y5M16D ~ 2Y11M15D
      } else if (
        2 * 365 + 5 * monthDay + 15 < exactDay &&
        exactDay <= 2 * 365 + 11 * monthDay + 15
      ) {
        this.navigateToQuestionnaire(8);
        // 2Y11M16D ~ 3Y5M15D
      } else if (
        2 * 365 + 11 * monthDay + 15 < exactDay &&
        exactDay <= 3 * 365 + 5 * monthDay + 15
      ) {
        this.navigateToQuestionnaire(9);
        // 3Y5M16D ~ 3Y11M15D
      } else if (
        3 * 365 + 5 * monthDay + 15 < exactDay &&
        exactDay <= 3 * 365 + 11 * monthDay + 15
      ) {
        this.navigateToQuestionnaire(10);
        // 3Y11M16D ~ 4Y11M15D
      } else if (
        3 * 365 + 11 * monthDay + 16 <= exactDay &&
        exactDay <= 4 * 365 + 11 * monthDay + 15
      ) {
        this.navigateToQuestionnaire(11);
        // 4Y11M16D ~ 5Y11M15D
      } else if (
        4 * 365 + 11 * monthDay + 15 < exactDay &&
        exactDay <= 5 * 365 + 11 * monthDay + 15
      ) {
        this.navigateToQuestionnaire(12);
        // 5Y11M16D ~ 6Y11M15D
      } else if (
        5 * 365 + 11 * monthDay + 15 < exactDay &&
        exactDay <= 6 * 365 + 11 * monthDay + 15
      ) {
        this.navigateToQuestionnaire(13);
      } else if (6 * 365 + 11 * monthDay + 15 < exactDay) {
        this.setState({
          message: t("quickScreener.index.outOfRange1"),
        });
        this.setState({ active: true });
      } else {
        this.setState({
          message: t("quickScreener.index.outOfRange2"),
        });
        this.setState({ active: true });
      }
    }
  }

  handleDateChange = (event, { name, value }) => {
    if (this.state.hasOwnProperty(name)) {
      this.setState({ [name]: value } as Pick<
        LandingState,
        keyof LandingState
      >);
    }
  };

  handleSexChange(event) {
    const sex = event.currentTarget.textContent;
    this.setState({ sexSel: sex });
  }

  handleVisible(boolean) {
    this.setState({ visible: boolean });
  }

  render() {
    const active = this.state.active;
    const message = this.state.message;
    const { t } = this.props;

    const sexOptions = [
      { key: "男", value: "男", text: "男" },
      { key: "女", value: "女", text: "女" },
    ];
    const intro_paragraph_1 = t("quickScreener.index.introPara1");
    const intro_paragraph_2 = t("quickScreener.index.introPara2");
    const intro_paragraph_3 = t("quickScreener.index.introPara3");

    const languageOptions = [
      {
        key: "繁體中文 (Chinese - Traditional)",
        text: "繁體中文 (Chinese - Traditional)",
        value: "繁體中文 (Chinese - Traditional)",
      },
      {
        key: "简体中文 (Chinese - Simplified)",
        text: "简体中文 (Chinese - Simplified)",
        value: "简体中文 (Chinese - Simplified)",
      },
    ];

    return (
      <>
        {!this.state.isAccessGranted ? (
          <Modal
            open={this.state.isModalOpen}
            onClose={this.handleModalClose}
            closeOnDimmerClick={false}
            style={{ padding: "20px", margin: "20px" }}
          >
            <Modal.Header>
              {t("quickScreener.index.enterActivationCode")}
            </Modal.Header>
            <Modal.Content>
              <Input
                type="text"
                placeholder={t("quickScreener.index.activationCode")}
                value={this.state.activationCode}
                onChange={this.handleActivationCodeChange}
              />
            </Modal.Content>
            <Modal.Actions>
              <Button onClick={this.handleModalClose}>Submit</Button>
            </Modal.Actions>
          </Modal>
        ) : null}
        <div>
          <Dimmer active={active} onClickOutside={this.handleClose} page>
            <Header as="h2" icon inverted>
              <Message warning size="small">
                <Message.Header>
                  {t("quickScreener.index.warning")}
                </Message.Header>

                <p>{message}</p>

                <Button onClick={this.handleClose}>
                  {t("quickScreener.index.back")}
                </Button>
                <p></p>

                <Button
                  onClick={(e) => {
                    window.open(
                      "http://www.qierbao.com/contact",
                      "_blank" // <- This is what makes it open in a new window.
                    );
                  }}
                >
                  {t("quickScreener.index.contact")}
                </Button>
              </Message>
            </Header>
          </Dimmer>
          <Sidebar
            as={Menu}
            animation="overlay"
            icon="labeled"
            inverted
            onHide={() => this.handleVisible(false)}
            vertical
            visible={this.state.visible}
            width="thin"
            style={{ backgroundColor: "white" }}
          >
            <br />
            <a
              className="waves-effect waves-light btn-medium teal-text text-accent-4"
              onClick={() => this.handleVisible(false)}
            >
              <Icon name="angle double left" />
              <b>文 | A</b>
            </a>
            <br />
            <br />
            <Menu.Item
              as="a"
              style={{ color: "black" }}
              onClick={() =>
                this.handleMobileChange("繁體中文 (Chinese - Traditional)")
              }
            >
              繁體中文 (Chinese - Traditional)
            </Menu.Item>

            <Menu.Item
              as="a"
              style={{ color: "black" }}
              onClick={() =>
                this.handleMobileChange("简体中文 (Chinese - Simplified)")
              }
            >
              简体中文 (Chinese - Simplified)
            </Menu.Item>
          </Sidebar>

          <SidebarPusher>
            <TopBar page="index">
              <DesktopOrLaptop>
                <Dropdown
                  button
                  className="icon left"
                  labeled
                  icon="world"
                  options={languageOptions}
                  text={this.codeToText(this.props.i18n.language)}
                  onChange={this.handleChange}
                  style={{
                    display: "float",
                    float: "left",
                    marginTop: "0.8rem",

                    marginLeft: "2rem",
                  }}
                />
              </DesktopOrLaptop>

              <TabletOrMobile>
                <div className="sideMenu"></div>
                <Icon
                  style={{
                    display: "float",
                    float: "left",
                    marginTop: "1.3rem",
                    paddingLeft: "2rem",
                    cursor: "pointer",
                    paddingBottom: "0.5rem",
                  }}
                  onClick={() => this.handleVisible(true)}
                  name="language"
                  color="black"
                  size="big"
                />
              </TabletOrMobile>
              <TopBarContent device={isBrowser ? "browser" : "mobile"}>
                <p
                  style={{
                    display: "inline-block",
                    paddingTop: "1rem",
                    fontSize: "2.3rem",
                    ...(isBrowser
                      ? {
                          marginRight: "22rem",
                        }
                      : {
                          marginRight: "1rem",
                        }),
                  }}
                >
                  {t("quickScreener.index.topbar")}
                </p>
              </TopBarContent>
            </TopBar>

            <LandingBody page="grey" device={isBrowser ? "browser" : "mobile"}>
              <Grid>
                <Grid.Row style={{ padding: 0 }}>
                  <Grid.Column width={isBrowser ? 5 : 1}></Grid.Column>

                  <Grid.Column width={isBrowser ? 6 : 14}>
                    <div>
                      <WelcomeImage
                        device={isBrowser ? "browser" : "mobile"}
                        src={WelcomeImg}
                      />
                    </div>
                  </Grid.Column>

                  <Grid.Column width={isBrowser ? 5 : 1}></Grid.Column>
                </Grid.Row>
                <Grid.Row style={{ padding: 0 }}>
                  <Grid.Column width={isBrowser ? 5 : 1}></Grid.Column>
                  <Grid.Column width={isBrowser ? 6 : 14}>
                    <div>
                      <LandingBodyBox>
                        <LandingBodyBoxContent>
                          <Centralise>
                            <strong>
                              <h3>{t("quickScreener.index.introTitle")}</h3>
                            </strong>
                          </Centralise>
                          <br />
                          <p>{intro_paragraph_1}</p>
                          <p>{intro_paragraph_2}</p>
                          <Centralise>
                            <i>
                              <p style={{ fontWeight: "lighter" }}>
                                {intro_paragraph_3}
                              </p>
                            </i>
                          </Centralise>
                        </LandingBodyBoxContent>
                        <br />
                        <Centralise>
                          <DesktopOrLaptop>
                            <Grid columns={2}>
                              <Grid.Column>
                                <Select
                                  placeholder={t(
                                    "quickScreener.index.genderPlaceholder"
                                  )}
                                  options={sexOptions}
                                  onChange={this.handleSexChange}
                                />
                              </Grid.Column>
                              <Grid.Column>
                                <DateInput
                                  className="browser-default "
                                  name="dateSel"
                                  maxDate={moment().toDate()}
                                  closable
                                  clearable
                                  autoComplete="off"
                                  placeholder={t(
                                    "quickScreener.index.birthdayPlaceholder"
                                  )}
                                  value={this.state.dateSel}
                                  clearIcon={<Icon name="remove" color="red" />}
                                  iconPosition="left"
                                  onChange={this.handleDateChange}
                                  // animation="none"
                                  startMode="year"
                                  localization="zh-cn"
                                  dateFormat="MM-DD-YYYY"
                                  onFocus={(e) => (e.target.readOnly = true)}
                                />
                              </Grid.Column>
                            </Grid>
                            <Grid columns={1}>
                              <Grid.Column>
                                <Input
                                  placeholder={t(
                                    "quickScreener.index.nanshanMemberProjectCode"
                                  )}
                                  value={this.state.agentID}
                                  onChange={this.handleAgentIDChange}
                                />
                              </Grid.Column>
                            </Grid>
                          </DesktopOrLaptop>
                          <TabletOrMobile>
                            <Select
                              placeholder={t(
                                "quickScreener.index.genderPlaceholder"
                              )}
                              options={sexOptions}
                              onChange={this.handleSexChange}
                              style={{ width: "70%", marginBottom: "1.5rem" }}
                            />
                            <DateInput
                              className="browser-default "
                              name="dateSel"
                              maxDate={moment().toDate()}
                              closable
                              clearable
                              placeholder={t(
                                "quickScreener.index.birthdayPlaceholder"
                              )}
                              value={this.state.dateSel}
                              clearIcon={<Icon name="remove" color="red" />}
                              iconPosition="left"
                              onChange={this.handleDateChange}
                              // animation="none"
                              startMode="year"
                              localization="zh-cn"
                              style={{ width: "70%", marginBottom: "1.5rem" }}
                              dateFormat="MM-DD-YYYY"
                              onFocus={(e) => (e.target.readOnly = true)}
                            />
                            <Input
                              placeholder={t(
                                "quickScreener.index.nanshanMemberProjectCode"
                              )}
                              value={this.state.agentID}
                              onChange={this.handleAgentIDChange}
                              style={{ width: "70%" }}
                            />
                          </TabletOrMobile>
                        </Centralise>
                        <br />
                        <Centralise>
                          <Button onClick={this.onSubmit} type="submit">
                            {t("quickScreener.index.start")}
                          </Button>
                        </Centralise>
                      </LandingBodyBox>
                    </div>
                  </Grid.Column>
                  <Grid.Column width={isBrowser ? 5 : 1}></Grid.Column>
                </Grid.Row>
              </Grid>
              <Footer />
            </LandingBody>
          </SidebarPusher>
        </div>
      </>
    );
  }
}

export default withTranslation()(withRouter(Landing));
